/* eslint-env browser */
import * as ActionTypes from 'actions';

const initialState = {
  isLoading: true,
  id: '',
  email: '',
  password: '',
  retype_pass: '',
  first_name: '',
  last_name: '',
  address: '',
  city: '',
  state: '',
  state_data: [],
  state_title: '',
  zip: '',
  work_phone: '',
  cell_phone: '',
  home_phone: '',
  fax: '',
  config: {},
  type: '',
  action: '',
  notice_msgs: [],
};

export default function(state = initialState, action = {}) {
  const { type, response, error, id, code, page_type, state_string } = action;

  switch (type) {

  case ActionTypes.ACTIVATE_LOAD_REQUEST:
  case ActionTypes.ACTIVATE_REQUEST:
  case ActionTypes.SETUP_LOAD_REQUEST:
  case ActionTypes.SETUP_REQUEST:
  case ActionTypes.CONVERT_LOAD_REQUEST:
  case ActionTypes.CONVERT_REQUEST:
    return { ...state, isLoading: true };

  case ActionTypes.ACTIVATE_LOAD_SUCCESS:
  case ActionTypes.ACTIVATE_SUCCESS:
  case ActionTypes.SETUP_LOAD_SUCCESS:
  case ActionTypes.SETUP_SUCCESS:
  case ActionTypes.CONVERT_LOAD_SUCCESS:
  case ActionTypes.CONVERT_SUCCESS:
    return { ...state, isLoading: false, ...response };

  case ActionTypes.ACTIVATE_LOAD_FAILURE:
  case ActionTypes.ACTIVATE_FAILURE:
  case ActionTypes.SETUP_LOAD_FAILURE:
  case ActionTypes.SETUP_FAILURE:
  case ActionTypes.CONVERT_LOAD_FAILURE:
  case ActionTypes.CONVERT_FAILURE:
    return { ...state, isLoading: false };

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/activate.js